(function () {
  var root = document.querySelector("[data-fb-protein]");
  if (!root) return;

  var TOTAL = 12;
  var RESULT = 13;
  var modal = root.querySelector("[data-fb-modal]");
  var hook = root.querySelector(".fb-hook");
  var resultEl = root.querySelector("[data-fb-result]");
  var progress = root.querySelector("[data-fb-progress]");
  var progressLabel = root.querySelector("[data-fb-progress-label]");
  var nameInput = root.querySelector("[data-fb-name]");
  var heightInput = root.querySelector("[data-fb-height]");
  var heightNum = root.querySelector("[data-fb-height-num]");
  var kgInput = root.querySelector("[data-fb-kg]");
  var gInput = root.querySelector("[data-fb-g]");
  var advancing = false;
  var storeCta = root.querySelector("[data-fb-store-cta]");
  var mailName = root.querySelector("[data-fb-mail-name]");
  var mailTags = root.querySelector("[data-fb-mail-tags]");
  var mailForm = root.querySelector("#fb-protein-email");

  var STORES = {
    "saint-denis": "Saint-Denis",
    "saint-paul": "Saint-Paul",
    "saint-pierre": "Saint-Pierre",
    "saint-andre": "Saint-André",
    online: null
  };

  var PLATE_OMNI = [
    { key: "egg", name: "Œufs", portion: "2 gros, 100 g", grams: 13 },
    { key: "yogurt", name: "Yaourt grec", portion: "150 g", grams: 15 },
    { key: "milk", name: "Lait", portion: "1 verre, 250 ml", grams: 8 },
    { key: "chicken", name: "Filet de poulet", portion: "125 g cuit", grams: 39 },
    { key: "ham", name: "Jambon", portion: "2 tranches, 50 g", grams: 10 },
    { key: "bread", name: "Pain complet", portion: "2 tranches, 80 g", grams: 10 },
    { key: "pasta", name: "Pâtes cuites", portion: "200 g", grams: 12 },
    { key: "rice", name: "Riz basmati cuit", portion: "150 g", grams: 4 },
    { key: "oats", name: "Flocons d’avoine", portion: "40 g secs", grams: 5 }
  ];

  var PLATE_PLANT = [
    { key: "tofu", name: "Tofu ferme", portion: "200 g", grams: 22 },
    { key: "lentils", name: "Lentilles cuites", portion: "200 g", grams: 18 },
    { key: "chickpeas", name: "Pois chiches", portion: "150 g", grams: 13 },
    { key: "quinoa", name: "Quinoa cuit", portion: "150 g", grams: 7 },
    { key: "milk", name: "Lait de soja", portion: "1 verre, 250 ml", grams: 8 },
    { key: "bread", name: "Pain complet", portion: "2 tranches, 80 g", grams: 10 },
    { key: "pasta", name: "Pâtes cuites", portion: "200 g", grams: 12 },
    { key: "rice", name: "Riz basmati cuit", portion: "150 g", grams: 4 },
    { key: "oats", name: "Flocons d’avoine", portion: "40 g secs", grams: 5 }
  ];

  var foodImgs = {};
  try {
    var imgNode = root.querySelector("[data-fb-food-img]");
    if (imgNode) foodImgs = JSON.parse(imgNode.textContent);
  } catch (e) {}

  var SINGLE = ["age", "sex", "goal", "activity", "training", "diet", "location"];

  var state = {
    step: 0,
    name: "",
    age: "",
    sex: "",
    height: 170,
    kg: 75,
    grams: 0,
    weight: 75,
    goal: "",
    activity: "",
    training: "",
    health: [],
    sports: [],
    diet: "",
    location: "",
    gramsNeed: 0,
    shakers: 1,
    source: "dose"
  };

  function pricePer25(cents, weightG, protPer100) {
    var total = weightG * protPer100 / 100;
    var n = Number(cents) / 100 * 25 / total;
    if (!isFinite(n) || n <= 0) return "";
    return n.toFixed(2).replace(".", ",") + " € / 25 g de prot";
  }

  function track(name, payload) {
    console.log(name, payload || {});
  }

  function save() {
    try {
      sessionStorage.setItem("fb-protein", JSON.stringify(state));
    } catch (e) {}
  }

  function load() {
    try {
      return JSON.parse(sessionStorage.getItem("fb-protein") || "null");
    } catch (e) {
      return null;
    }
  }

  function coeff(goal, training, activity) {
    var c = { mass: 1.6, muscle: 1.8, maintain: 1.5, cut: 2.0 }[goal] || 1.5;
    if (training === "sedentary" || activity === "sedentary") c -= 0.2;
    if (training === "high") c += 0.1;
    return Math.min(2.2, Math.max(1.2, c));
  }

  function syncWeight() {
    var kg = Math.min(150, Math.max(40, Number(kgInput.value) || 75));
    var g = Math.min(999, Math.max(0, Number(gInput.value) || 0));
    kgInput.value = String(kg);
    gInput.value = String(g);
    state.kg = kg;
    state.grams = g;
    state.weight = Math.round((kg + g / 1000) * 1000) / 1000;
  }

  function calcGrams(weight, goal, training, activity) {
    return Math.round((weight * coeff(goal, training, activity)) / 5) * 5;
  }

  function isPlant(diet) {
    return diet === "veggie" || diet === "vegan";
  }

  function setHeight(val) {
    var n = Number(val);
    state.height = n;
    heightNum.textContent = String(n);
    var p = ((n - 140) / 70) * 100;
    heightInput.style.setProperty("--fb-p", p + "%");
  }

  function steps() {
    return root.querySelectorAll(".fb-step");
  }

  function syncChoices() {
    SINGLE.forEach(function (key) {
      root.querySelectorAll('[data-fb-choice="' + key + '"]').forEach(function (el) {
        el.classList.toggle("is-on", el.getAttribute("data-value") === state[key]);
      });
    });
    ["health", "sports"].forEach(function (key) {
      var selected = state[key] || [];
      root.querySelectorAll('[data-fb-choice="' + key + '"]').forEach(function (el) {
        el.classList.toggle("is-on", selected.indexOf(el.getAttribute("data-value")) !== -1);
      });
    });
  }

  function showStep(n) {
    advancing = false;
    state.step = n;
    steps().forEach(function (el) {
      var on = Number(el.getAttribute("data-step")) === n;
      el.hidden = !on;
      el.classList.toggle("is-on", on);
    });
    var current = Math.min(n, TOTAL);
    progress.style.width = Math.round((current / TOTAL) * 100) + "%";
    progressLabel.textContent = current + " / " + TOTAL;
    syncChoices();
    if (n === 1) nameInput.focus();
    if (n === 4) heightInput.focus();
    if (n === 5) kgInput.focus();
    save();
  }

  function openModal(source) {
    state.source = source || "dose";
    modal.hidden = false;
    document.body.style.overflow = "hidden";
    track("QuizStart", { source: state.source });
    showStep(1);
    track("QuizStep", { step: 1 });
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = "";
    state.step = 0;
  }

  function showResult() {
    modal.hidden = true;
    document.body.style.overflow = "";
    if (hook) hook.hidden = true;
    if (resultEl) resultEl.hidden = false;
    state.step = RESULT;
    save();
    if (resultEl) resultEl.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function nextFrom(step) {
    if (step === 1) {
      var name = (nameInput.value || "").trim();
      if (!name) {
        nameInput.focus();
        return;
      }
      state.name = name;
    }
    if (step === 4) state.height = Number(heightInput.value);
    if (step === 5) {
      syncWeight();
      if (!state.weight) {
        kgInput.focus();
        return;
      }
    }
    if (step === 9 && state.health.length < 1) return;
    if (step === 10 && state.sports.length < 1) return;
    track("QuizStep", { step: step + 1, from: step });
    if (step === TOTAL) complete();
    else showStep(step + 1);
  }

  function complete() {
    state.gramsNeed = calcGrams(state.weight, state.goal, state.training, state.activity);
    track("QuizComplete", {
      name: state.name,
      age: state.age,
      sex: state.sex,
      height: state.height,
      weight: state.weight,
      goal: state.goal,
      activity: state.activity,
      training: state.training,
      health: state.health,
      sports: state.sports,
      diet: state.diet,
      location: state.location,
      grams: state.gramsNeed
    });
    renderResult();
    showResult();
    track("ResultView", { grams: state.gramsNeed, location: state.location });
  }

  function renderResult() {
    var plant = isPlant(state.diet);
    var name = state.name || "Toi";
    root.querySelector("[data-fb-out-name]").textContent = name;
    var gramsEl = root.querySelector("[data-fb-out-grams]");
    countTo(gramsEl, state.gramsNeed);

    var plate = plant ? PLATE_PLANT : PLATE_OMNI;
    var food = plate.reduce(function (sum, row) {
      return sum + row.grams;
    }, 0);
    var gap = Math.max(0, state.gramsNeed - food);
    var sh = Math.round(gap / 25);
    if (sh < 1) sh = 1;
    if (sh > 2) sh = 2;
    state.shakers = sh;

    var split =
      "4 prises, dont " +
      state.shakers +
      " shaker" +
      (state.shakers > 1 ? "s" : "") +
      " à 25 g. Le reste vient de l’assiette.";
    root.querySelector("[data-fb-out-split]").textContent = split;

    var shakeG = state.shakers * 25;
    var shakeLabel = plant
      ? state.shakers > 1
        ? "2 shakers végétaux"
        : "1 shaker végétal"
      : state.shakers > 1
        ? "2 scoops Arkens"
        : "1 scoop Arkens";
    var arkensPer25 = pricePer25(root.getAttribute("data-arkens-price"), 750, 87);
    var clearPer25 = pricePer25(root.getAttribute("data-clear-price"), 600, 76);
    var per25Arkens = root.querySelector("[data-fb-out-per25-arkens]");
    var per25Clear = root.querySelector("[data-fb-out-per25-clear]");
    if (per25Arkens) per25Arkens.textContent = arkensPer25;
    if (per25Clear) per25Clear.textContent = clearPer25;

    function foodCard(row, extraClass) {
      var src = foodImgs[row.key] || "";
      var img = src
        ? '<img src="' + src + '" alt="' + row.name + '" width="160" height="160" loading="lazy">'
        : "";
      var price = row.price
        ? '<span class="fb-food__price">' + row.price + "</span>"
        : "";
      return (
        '<li class="fb-food' +
        (extraClass ? " " + extraClass : "") +
        '">' +
        img +
        '<div class="fb-food__txt"><span class="fb-food__name">' +
        row.name +
        '</span><span class="fb-food__portion">' +
        row.portion +
        "</span>" +
        price +
        "</div><strong>" +
        row.grams +
        " g</strong></li>"
      );
    }

    var cards = plant
      ? [
          foodCard(
            {
              key: "",
              name: shakeLabel,
              portion: "25 g par shaker",
              grams: shakeG
            },
            "fb-food--shake"
          )
        ]
      : [
          foodCard(
            {
              key: "whey",
              name: "Whey Arkens Isolate",
              portion: state.shakers > 1 ? "2 scoops" : "1 scoop",
              grams: shakeG,
              price: arkensPer25
            },
            "fb-food--whey"
          )
        ];
    var list = root.querySelector("[data-fb-out-plate]");
    list.innerHTML = cards.concat(plate.map(function (row) { return foodCard(row); })).join("");
    root.querySelector("[data-fb-out-plate-total]").textContent =
      "Total aliment + shaker ≈ " + (food + shakeG) + " g, autour de ton chiffre.";

    root.querySelector('[data-prod="arkens"]').hidden = plant;
    root.querySelector('[data-prod="clear"]').hidden = plant;
    root.querySelector('[data-prod="plant"]').hidden = !plant;

    var scoop = state.shakers === 2 ? "2 scoops dans la journée, 25 g de protéines chacun." : "1 scoop ≈ 25 g de protéines. Un shaker, le reste à l’assiette.";
    var doseA = root.querySelector("[data-fb-out-dose-arkens]");
    var doseC = root.querySelector("[data-fb-out-dose-clear]");
    if (doseA) doseA.textContent = scoop;
    if (doseC) doseC.textContent = state.shakers === 2 ? "2 scoops, plus légère que l’Arkens." : "1 scoop. Plus légère, façon jus.";

    var storeName = STORES[state.location];
    var productUrl = plant ? root.getAttribute("data-whey-url") : root.getAttribute("data-arkens-url");
    if (storeName) {
      storeCta.textContent = "Retirer à " + storeName;
      storeCta.href = productUrl;
    } else {
      storeCta.textContent = "Livraison 974, dès 90 €";
      storeCta.href = productUrl;
    }

    if (mailName) mailName.value = state.name;
    if (mailTags) {
      mailTags.value = ["plan-proteine", state.location, state.gramsNeed + "g", state.goal, state.age]
        .concat(state.health)
        .concat(state.sports)
        .join(",");
    }
    save();
  }

  function countTo(el, target) {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      el.textContent = String(target);
      return;
    }
    var start = performance.now();
    var dur = 640;
    function frame(now) {
      var t = Math.min(1, (now - start) / dur);
      el.textContent = String(Math.round(target * t));
      if (t < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  function toggleMulti(key, value, max) {
    var list = state[key].slice();
    var i = list.indexOf(value);
    if (i !== -1) list.splice(i, 1);
    else if (list.length < max) list.push(value);
    state[key] = list;
    root.querySelectorAll('[data-fb-choice="' + key + '"]').forEach(function (el) {
      el.classList.toggle("is-on", list.indexOf(el.getAttribute("data-value")) !== -1);
    });
  }

  root.querySelector("[data-fb-start]").addEventListener("click", function () {
    openModal("dose");
  });

  root.querySelector("[data-fb-back]").addEventListener("click", function () {
    if (state.step <= 1) closeModal();
    else showStep(state.step - 1);
  });

  root.querySelectorAll("[data-fb-next]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      nextFrom(state.step);
    });
  });

  nameInput.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      nextFrom(1);
    }
  });

  [kgInput, gInput].forEach(function (input) {
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        nextFrom(5);
      }
    });
    input.addEventListener("change", syncWeight);
  });

  heightInput.addEventListener("input", function () {
    setHeight(heightInput.value);
  });
  setHeight(heightInput.value);

  root.querySelectorAll("[data-fb-why]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var text = btn.nextElementSibling;
      if (text && text.classList.contains("fb-why-text")) text.hidden = !text.hidden;
    });
  });

  root.querySelectorAll("[data-fb-choice]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var key = btn.getAttribute("data-fb-choice");
      var value = btn.getAttribute("data-value");
      var max = Number(btn.getAttribute("data-fb-multi") || 0);
      if (max) {
        toggleMulti(key, value, max);
        return;
      }
      if (advancing) return;
      state[key] = value;
      root.querySelectorAll('[data-fb-choice="' + key + '"]').forEach(function (el) {
        el.classList.toggle("is-on", el === btn);
      });
      advancing = true;
      window.setTimeout(function () {
        nextFrom(state.step);
      }, 140);
    });
  });

  root.querySelectorAll("[data-fb-product]").forEach(function (link) {
    link.addEventListener("click", function () {
      track("ProductClick", {
        id: link.getAttribute("data-fb-product"),
        grams: state.gramsNeed,
        diet: state.diet
      });
    });
  });

  storeCta.addEventListener("click", function () {
    track("StoreClick", {
      location: state.location,
      label: storeCta.textContent,
      grams: state.gramsNeed
    });
  });

  if (mailForm) {
    mailForm.addEventListener("submit", function () {
      track("EmailSubmit", {
        grams: state.gramsNeed,
        location: state.location,
        diet: state.diet,
        newsletter: !!(mailForm.querySelector('[name="contact[accepts_marketing]"]') || {}).checked
      });
    });
  }

  var saved = load();
  if (saved && root.querySelector(".fb-mail__ok")) {
    Object.keys(state).forEach(function (k) {
      if (saved[k] !== undefined) state[k] = saved[k];
    });
    if (nameInput && state.name) nameInput.value = state.name;
    if (heightInput && state.height) {
      heightInput.value = state.height;
      setHeight(state.height);
    }
    if (kgInput) kgInput.value = String(state.kg || 75);
    if (gInput) gInput.value = String(state.grams || 0);
    syncWeight();
    renderResult();
    showResult();
  }
})();
